import Vue from 'vue'
import Vuex from 'vuex'
import messages from './modules/messages/main'
import user from './modules/user/main'
import state from './state'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    messages,
    user
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js